export default __webpack_public_path__ + "static/media/9.7ce51452.JPG";